<template>
    <admin-layout>
        <div class="content" slot="main">
            <h3>Default values</h3>
            <form class="form-vertical">
                <div class="form-group">
                    <label class="control-label">Default Dashboard</label>
                    <div>
                        <select class="form-control" v-model="accountModel.main_page">
                            <option value="null" disabled hidden>Pick one option</option>
                            <option v-for="choice in dashboardList"
                                    :value="choice.id">{{choice.name}}</option>
                        </select>
                    </div>
                </div>
            </form>
        </div>
        <footer slot="footer">
            <button class="btn btn-custom" @click="saveAccount()">Save</button>
        </footer>
    </admin-layout>
</template>

<script>
 import Vue from 'vue'; 
 import {AdminLayout} from 'components/layouts/';
 // Load the full build
 var _ = require('lodash');
 
 export default {
     components: {
         AdminLayout
     },
     
     data () {
         return {
             accountModel: {
                 main_page: null
             },
             dashboardList: []
         }
     },
     
     created () {
         this.fetchInitialData();
     },
     
     methods: {
         fetchInitialData () {
             var user = this.$store.state.user;
             var account = user.current_account;
             this.getAccountData(account);
             this.fetchDashboards();
         },
         getAccountData (account) {
             // if (!account.fieldmapping) {
             //   account.fieldmapping = {};
             // }
             this.accountModel = Vue.leadscorz.deep_clone(account);
         },
         fetchDashboards () {
             var self = this;
             API.dashboards.getList()
                .then(function (response) {
                    self.dashboardList = response.data.results;
                });
         },
         saveAccount: _.debounce(function () {
             var requestData = {};
             // Dashboard
             if (this.accountModel.main_page && this.accountModel.main_page != 'null') {
                 requestData.main_page = this.accountModel.main_page;
             }
             var self = this;
             
             API.accounts.update(this.accountModel.id, requestData)
                .then(function (response) {
                    var account = response.data;
                    self.getAccountData(account);
                    Vue.toast('Changes saved successfully!', {
                        className: ['et-info'],
                    });
                });
             
         }, 500),
     }    
 }
</script>
<style>
</style>




// WEBPACK FOOTER //
// AccountSettings.vue?235c232c